// extracted by mini-css-extract-plugin
module.exports = {"content":"Content-module--content--3Ln_2","content__title":"Content-module--content__title--Jdbtz","content__body":"Content-module--content__body--3bvEm"};